<template>
  <div>
    <label for="status" class="block text-sm font-bold text-gray-600">
      {{ label }}
    </label>
    <select
      :disabled="disabled"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      class="border-0 px-3 py-2 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
    >
      <option
        v-for="(option, index) in options"
        :key="index"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: "SelectField",
  props: {
    label: {
      type: String,
      required: false
    },
    options: {
      type: Array,
      required: true
    },
    modelValue: {
      type: [String, Array, Object, Boolean, Number]
    },
    placeholder: {
      type: String
    },
    disabled: {
      type: Boolean
    }
  }
};
</script>
